import { Grid, Container, Stepper, Step, StepLabel } from '@mui/material'

import { LegalizationPaymentStep } from './LegalizationPaymentStep'
import { ManagementInfoStep } from './ManagementInfoStep'
import { FilesAttachmentStep } from './FilesAttachmentStep'
import { DefaultFinishStep } from './DefaultFinishStep'

// Array que define cuantos pasos va a tener
const steps = ['Info. gestión', 'Pago legalización', 'Archivos adjuntos']

export const ExtensionOfTermSection = ({ useFetchInit }) => {

    const { 
        //------------- Generales
        // location,
        // paramsURL,
        //------------- globalStates
        globalStates,
        //------------- FetchData
        // FetchData,
        //------------- Actions
        Actions,
        //------------- helpers
        // Helpers,
        //------------- Formularios
        // Forms
        
    } = useFetchInit

    // ------------------------------------------------ Generales
        
    // ------------------------------------------------ globalStates
    const {stepApplilication} = globalStates

    // ------------------------------------------------ Helpers
    
    // ------------------------------------------------ Formularios
    
    // ------------------------------------------------ FetchData
    
    // ------------------------------------------------ Actions
    const {handleClickReturnStep, onSubmitChangeApprovalStep} = Actions

    const getStepContent = (stepApplilication) => {
        switch (stepApplilication) {
            case 0:
                return <ManagementInfoStep
                    useFetchInit = {useFetchInit}
                />
            case 1:
                return <LegalizationPaymentStep 
                    useFetchInit = {useFetchInit}
                />;
            case 2:
                return <FilesAttachmentStep
                    useFetchInit = {useFetchInit}
                />;
            default:
                throw new Error('Unknown step');
        }
    }

    return (
        <>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Container component="main" maxWidth="md" sx={{ mb: 4 }}>
                        <Stepper activeStep={stepApplilication} sx={{ pt: 3, pb: 5 }}>
                            {steps.map((label) => (
                                <Step key={label}>
                                    <StepLabel>{label}</StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                    </Container>
                    <p className='text-danger'>* campos obligatorios</p>
                    {stepApplilication === steps.length ? (
                        <DefaultFinishStep
                            handleClickReturnStep={handleClickReturnStep}
                            onSubmitChangeApprovalStep={onSubmitChangeApprovalStep}
                        />

                    ) : (
                        <>
                            {getStepContent(stepApplilication)}
                        </>
                    )}
                </Grid> 
            </Grid>
        </>
    )
}
